import { render, staticRenderFns } from "./OnePlatformGeneralConsent.vue?vue&type=template&id=1a86cc73&scoped=true&"
import script from "./OnePlatformGeneralConsent.vue?vue&type=script&lang=js&"
export * from "./OnePlatformGeneralConsent.vue?vue&type=script&lang=js&"
import style0 from "./OnePlatformGeneralConsent.vue?vue&type=style&index=0&id=1a86cc73&prod&lang=css&"
import style1 from "./OnePlatformGeneralConsent.vue?vue&type=style&index=1&id=1a86cc73&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a86cc73",
  null
  
)

export default component.exports